import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/image/logo_login.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "forgot-password-container row" }
const _hoisted_4 = { class: "forgot-password-wrap card col-md-5 m-auto" }
const _hoisted_5 = { class: "align-items-center py-5" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-9 mx-auto" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "forgot-password-content d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"height":"inherit"}
  })
], -1)
const _hoisted_9 = { class: "text-center mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "text-center text-danger mb-3"
}
const _hoisted_12 = {
  key: 0,
  class: "row mb-4"
}
const _hoisted_13 = { class: "col-md-9 mx-auto" }
const _hoisted_14 = {
  key: 1,
  class: "row mb-4"
}
const _hoisted_15 = { class: "col-md-9 d-flex mx-auto" }
const _hoisted_16 = { class: "col-md-12 d-grid shadow" }
const _hoisted_17 = {
  key: 2,
  class: "row mb-4"
}
const _hoisted_18 = { class: "col-md-9 mx-auto" }
const _hoisted_19 = {
  key: 3,
  class: "row mb-4"
}
const _hoisted_20 = { class: "col-md-9 mx-auto" }
const _hoisted_21 = { class: "forgot-password-icon forgot-password-icon-sent d-flex align-items-center justify-content-center" }
const _hoisted_22 = { class: "text-center mb-4 forgot-password-sent-font" }
const _hoisted_23 = {
  key: 4,
  class: "row mb-4"
}
const _hoisted_24 = { class: "col-md-9 mx-auto" }
const _hoisted_25 = { class: "forgot-password-icon forgot-password-icon-error d-flex align-items-center justify-content-center" }
const _hoisted_26 = { class: "text-center mb-4 forgot-password-error-font" }
const _hoisted_27 = { class: "row mb-4" }
const _hoisted_28 = { class: "col-md-9 mx-auto text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        name: "form",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("h3", _hoisted_9, [
                    _createTextVNode("BERJAYA FINANCE - RPK "),
                    _hoisted_10,
                    (_ctx.envMode != null && _ctx.envMode != '')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "[" + _toDisplayString(_ctx.envMode) + "]", 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (_ctx.sentMessage == null && _ctx.token == null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_InputText, {
                        class: "p-inputtext",
                        type: "text",
                        maxlength: "50",
                        placeholder: "Email Address",
                        modelValue: _ctx.user.username,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.username) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.sentMessage == null && _ctx.token == null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_Button, {
                          class: "p-button-lg text-uppercase",
                          onClick: _ctx.forgotPassword,
                          disabled: _ctx.v$.$invalid || _ctx.isLoading,
                          label: "Reset Password"
                        }, null, 8, ["onClick", "disabled"])
                      ]),
                      (_ctx.isLoading)
                        ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.sentMessage == null && _ctx.token != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      (_ctx.isLoading)
                        ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.sentMessage != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_FontAwesomeIcon, { icon: ['fas', 'check'] })
                      ]),
                      _createElementVNode("h6", _hoisted_22, _toDisplayString(_ctx.sentMessage), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.sentErrorMessage != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_FontAwesomeIcon, { icon: ['fas', 'xmark'] })
                      ]),
                      _createElementVNode("h6", _hoisted_26, _toDisplayString(_ctx.sentErrorMessage), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_Button, {
                    class: "p-button-link",
                    label: "Back to Login",
                    onClick: _ctx.back
                  }, null, 8, ["onClick"])
                ])
              ])
            ]),
            _createVNode(_component_TheFooter, { hideCompany: true })
          ])
        ])
      ], 32)
    ])
  ]))
}